module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vvc-menu-bar"
  }, _vm._l((_vm.menus), function(menu) {
    return _c('menu-item', {
      attrs: {
        "useRouter": _vm.config.useRouter,
        "activeMenu": _vm.activeMenu,
        "menu": menu
      },
      on: {
        "menuItem_activate": _vm.emitActivate
      }
    }, [_c('span', {
      staticClass: "menu-icon"
    })])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-5f5ee914!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/tofu-menu/src/menu.vue
// module id = 657
// module chunks = 0